// src/config/ads.ts
//
// ┌─────────────────────────────────────────────────────────────────────────┐
// │ 구글 애드센스 설정                                                        │
// │                                                                         │
// │ ※ 자동광고(Auto ads)는 public/index.html 의 adsbygoogle.js 스크립트가     │
// │   담당합니다. 그 스크립트는 절대 제거하지 마세요.                          │
// │                                                                         │
// │ 아래 AD_SLOTS 는 "수동 광고 단위"입니다. 현재는 본문 중간 반응형           │
// │ 디스플레이 광고 1개만 사용하며, 모든 페이지에 공통으로 딱 한 번 노출됩니다. │
// │ (배치 컴포넌트: src/components/ads/InContentAd.tsx)                       │
// │                                                                         │
// │ 슬롯 ID를 빈 문자열로 두면 해당 광고는 렌더링되지 않습니다               │
// │ (자동광고에는 영향 없음).                                                 │
// └─────────────────────────────────────────────────────────────────────────┘

/** 애드센스 게시자 ID (public/index.html 의 client 와 반드시 동일해야 함) */
export const ADSENSE_CLIENT = 'ca-pub-4223918454510903';

/**
 * 수동 광고 단위 슬롯 ID.
 * 빈 문자열이면 해당 위치의 수동 광고는 렌더링되지 않습니다(자동광고는 계속 동작).
 */
export const AD_SLOTS = {
    /** 본문 중간 · 반응형 디스플레이(고브인포 디스플레이광고) — 페이지당 1회 */
    inArticle: '8135453927',
} as const;

export type AdSlotKey = keyof typeof AD_SLOTS;
